export const toPositive = (number: number) => Math.max(number, 0);
